var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cloudPay"},[_c('p',[_vm._v("分类：")]),_c('div',{staticStyle:{"padding":"10px 0"}},_vm._l((_vm.$store.state.yunVarity),function(item,index){return _c('AuthChooseItem',{key:index,attrs:{"selected":item.id == _vm.$route.params.id,"name":item.name},on:{"click":function($event){return _vm.click(item)}}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }